export const environment = {
  production: true,
  ACCESS_CONTROL_API_PATH: 'web/components-api/access-control',
  APP_NAME: 'Document Engine',
  BASE_URL: '',
  CONTEXT: '/dpsinclair',
  COOKIE_NAME: 'dpsinclair',
  WEB_API_PATH: 'rest'
};
